<template>
    <div>
        <div class="container-fluid">
            <selected-device
                v-if="pageDTO.selectedDeviceDTO"
                class="d-flex flex-column align-items-md-start mt-1"
                :title="pageDTO.selectedDeviceDTO.title"
                :text="pageDTO.selectedDeviceDTO.text"
                :complementary-text="pageDTO.selectedDeviceDTO.complementaryText"
                :modify-button="pageDTO.selectedDeviceDTO.modifyButton"
                :delete-button="pageDTO.selectedDeviceDTO.deleteButton"
            />

            <offer
                :offer="currentOffer"
                :blocked-or-not-label="labels.blockedOrNot"
                :new-client-label="labels.newClient"
                :already-client-label="labels.alreadyClient"
                :advantage-messages="pageDTO.advantageMessages"
                :info-options="pageDTO.infoOptions"
                :is-online-recovery-available="pageDTO.onlineRecoveryAvailable"
            />

            <div v-if="currentOffer.pushZigZagDTO">
                <push-zig-zag :zigzag="currentOffer.pushZigZagDTO" />
            </div>

            <div v-if="currentOffer.withBlockedOfferToggle">
                <div
                    v-if="currentOffer.hasBlockedVersion"
                    id="version-blocked-selection"
                    class="row"
                    :class="currentOffer.blocked ? '' : 'pb-1'"
                >
                    <div class="col-12 lead py-1">
                        <strong> {{ labels.selectVersion }} </strong>
                    </div>
                    <form autocomplete="off" class="col-12">
                        <ob1-radio-button-list
                            :with-box="true"
                            :radios-buttons="pageDTO.radioButtonCardDTO.radioButtonList"
                            @change="onVersionChange"
                        />
                    </form>
                </div>

                <div v-if="currentOffer.blocked" id="messageBlocked" class="row">
                    <div class="col-12">
                        <ob1-liens-haut-bas
                            button-id="blocked-link"
                            collapsed-block-id="blocked-offer"
                            :button-label="pageDTO.blockedOfferConditionsDTO.title"
                            :is-mini="false"
                        >
                            <p class="text-mw d-flex flex-column">
                                <span class="mb-1"> {{ pageDTO.blockedOfferConditionsDTO.line1 }} </span>
                                <span> {{ pageDTO.blockedOfferConditionsDTO.line2 }} </span>
                                <span class="mt-1"> {{ pageDTO.blockedOfferConditionsDTO.line3 }} </span>
                            </p>
                        </ob1-liens-haut-bas>
                    </div>
                </div>
            </div>
            <div v-else>
                <div v-if="currentOffer.blocked" id="messageBlocked" class="row">
                    <div class="col-12">
                        <strong>{{ pageDTO.blockedOfferConditionsDTO.title }}</strong>
                        <p class="text-mw d-flex flex-column">
                            <span class="my-1">{{ pageDTO.blockedOfferConditionsDTO.line1 }}</span>
                            <span>{{ pageDTO.blockedOfferConditionsDTO.line2 }}</span>
                            <span class="mt-1">{{ pageDTO.blockedOfferConditionsDTO.line3 }}</span>
                        </p>
                    </div>
                </div>
            </div>

            <brand-animation-section
                v-if="brandAnimation"
                class="container-fluid pt-2"
                :title="brandAnimation.title"
                :image="brandAnimation.image"
                :brand-advantages="brandAnimation.brandAdvantages"
            />

            <div class="mt-1">
                <ob1-liens
                    :href="pageDTO.fisLink.link"
                    :text="pageDTO.fisLink.text"
                    :with-arrow="true"
                    :target="'_blank'"
                />
            </div>
            <Faq class="mt-2" :title="pageDTO.faq.title" :question-list="pageDTO.faq.questionList" />
        </div>
        <div class="bg-gray2 mt-1">
            <div class="container-fluid">
                <div class="mt-4 mt-lg-2 pt-1">
                    <free-hands :text="pageDTO.handsFreeLabel" />
                </div>
                <div class="pt-xl-2 pb-3">
                    <ob1-legal-notice :button-id="pageDTO.legalMentions.title.headerId" :button-label="pageDTO.legalMentions.title.title" :collapsed-block-id="pageDTO.legalMentions.title.textId">
                        <div v-for="(mention, index) in pageDTO.legalMentions.mentions" :key="'mention-'+index">
                            <p class="small">
                                <strong v-if="mention.title">{{ mention.title }}</strong>
                                <span v-html="mention.text" />
                            </p>
                        </div>
                    </ob1-legal-notice>
                </div>
            </div>
        </div>
        <!--/* Zone Commitments */-->
        <div class="bg-dark">
            <div class="container-fluid">
                <orange-commitments :commitments="pageDTO.commitments" />
            </div>
        </div>
        <!--/* Zone Fil d'ariane */-->
        <div v-if="pageDTO.filArianeDTO" class="bg-dark">
            <div class="container-fluid py-1">
                <ob1-breadcrumb :items="pageDTO.filArianeDTO.items" is-inverse />
            </div>
        </div>
    </div>
</template>

<script>
import SelectedDevice from "../SelectedDevice.vue";
import PushZigZag from "../../../common/fragments/mobile/PushZigZag.vue";
import BrandAnimationSection from "../fragments/BrandAnimationSection.vue";
import Offer from "./Offer.vue";
import Faq from "../fragments/Faq.vue";
import FreeHands from "../../../common/components/FreeHands.vue";
import OrangeCommitments from "../components/OrangeCommitments.vue";

export default {
    name: "OfferDetailPage",
    components: {
        OrangeCommitments,
        FreeHands,
        Faq,
        SelectedDevice,
        PushZigZag,
        BrandAnimationSection,
        Offer
    },
    data: function () {
        return {
            pageDTO: dto,
            currentOffer: dto.offerDetailsDTO,
            offer: dto.offerDetailsDTO,
            equivalentOffer: dto.equivalentBlockedOrUnblockedOffer,
            brandAnimation: dto.brandAnimation,
            state: "loading",
            labels: dto.labels
        }
    },
    computed: {},
    created() {
        this.state = "loaded";
    },
    methods: {
        onVersionChange() {
            if (this.currentOffer.idSeo === this.offer.idSeo) {
                this.currentOffer = this.equivalentOffer
            } else {
                this.currentOffer = this.offer
            }
        },
    },
}
</script>
